/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { ToastContainer } from "react-toastify";

import { getRequest, postRequest } from "utils/request";
import { CircularProgress } from "@material-ui/core";

import "./style.css";

export default function LdapAuth({ history }) {
  const [login, setLogin] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    postRequest(`/authentications/ldap`, {
      user: login,
    })
      .then((e) => {
        if (e.success) {
          Swal.fire({
            title: "Usuário encontrado",
            text: `Problema relacionado a Teste`,
            showConfirmButton: true,
            confirmButtonText: "Re-configurar",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
          }).then((e) => {
            if (e.isConfirmed) {
              Swal.fire({
                title: "Atualizar senha",
                input: "password",
                inputLabel: "Senha anterior",
                inputValue: oldPassword,
                preConfirm: async (password) => {
                  await postRequest("/authentications/admin", {
                    login,
                    password,
                  })
                    .then((e) => {
                      if (!e.success) {
                        throw new Error(e.message);
                      } else {
                        Swal.fire({
                          input: "password",
                          inputLabel: "Informe uma nova senha",
                          inputValue: newPassword,
                          preConfirm: async () => {
                            getRequest(`/authentications/ldapchangepassword`)
                              .then((e) => {
                                if (!e.success) {
                                  throw new Error(e.message);
                                } else {
                                  Swal.fire("Senha atualizada com sucesso !");
                                }
                              })
                              .catch(() => {
                                Swal.fire("Erro ao atualizar a senha");
                              });
                          },
                        });
                      }
                    })
                    .catch((error) => {
                      Swal.showValidationMessage(`Erro ${error.message}`);
                    });
                },
              });
            }
          });
        } else {
          throw new Error("");
        }
      })
      .catch(() => {
        Swal.fire({ title: "Usuário não encontrado", icon: "warning" });
      }).finally(() => {
        setLoading(false)
      })
  };

  useEffect(() => {
    setNewPassword("");
    setOldPassword("");
  }, []);

  return (
    <>
      <ToastContainer autoClose={3000} />
      <div className="bg-login-page">
        <div className="container-login">
          <div className="login-content first-content ">
            <div className="first-column-login">
              <div className="logo">
                <img
                  className="img-logo"
                  src="assets/images/logo-omni.png"
                  alt="logo"
                />
              </div>
            </div>

            <div className="second-column-login">
              <h1 className="title-login">Autenticação por AD</h1>
              <form className="form-login" onSubmit={handleSubmit}>
                <div className="input-form-login">
                  <input
                    type="text"
                    placeholder="Usuário"
                    value={login}
                    required
                    name="user"
                    onChange={(e) => setLogin(e.target.value)}
                    style={{ paddingLeft: 15 }}
                  />
                </div>
                <div className="box-btn-login">
                  {!loading ? (
                    <button className="btn-login">Verificar</button>

                  ) : (
                    <CircularProgress />
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
